function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f0b543;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 47,
  cy: 47,
  r: 47
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M2.5,34.75A2.5,2.5,0,0,0,5,37.25H17.5V24.75H2.5Zm20,2.5H35a2.5,2.5,0,0,0,2.5-2.5v-10h-15Zm15-25H34.211A6.812,6.812,0,0,0,35,9.125,6.885,6.885,0,0,0,28.125,2.25c-3.25,0-5.352,1.664-8.047,5.336-2.7-3.672-4.8-5.336-8.047-5.336A6.885,6.885,0,0,0,5.156,9.125a6.716,6.716,0,0,0,.789,3.125H2.5A2.5,2.5,0,0,0,0,14.75V21a1.254,1.254,0,0,0,1.25,1.25h37.5A1.254,1.254,0,0,0,40,21V14.75A2.5,2.5,0,0,0,37.5,12.25Zm-25.477,0a3.125,3.125,0,0,1,0-6.25c1.555,0,2.7.258,6.727,6.25H12.023Zm16.1,0H21.4C25.414,6.273,26.531,6,28.125,6a3.125,3.125,0,0,1,0,6.25Z",
  transform: "translate(27.74 27.897)"
});

function SvgIconGiftcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftcard);
export default __webpack_public_path__ + "static/media/icon_giftcard.55f4649e.svg";
export { ForwardRef as ReactComponent };